module.exports = __webpack_public_path__ + "img/vertical_3_2_3016.81a32848.png";